module.exports = __webpack_public_path__ + "static/cashew_nuts_tieu_xanh_3-59f04c488efed56f8ef1396c151d42fc.jpg";